import { ApiKey, ServicesType } from "./types";

export const API_CONFIG: Record<ServicesType, ApiKey> = {
  heureka: {
    name: "Heureka",
    type: "heureka",
    modalSetter: "setHeurekaModalOpen",
    apiKeyField: "heurekaApiKey",
    onlyUsaVisible: false, // Not visible in USA
  },
  zbozi: {
    name: "Zboží.cz",
    type: "zbozi",
    modalSetter: "setZboziModalOpen",
    apiKeyField: "zboziApiKey",
    onlyUsaVisible: false, // Not visible in USA
  },
  spolehliveRecenze: {
    name: "Spolehlive Recenze",
    type: "spolehliveRecenze",
    modalSetter: "setSpolehliveRecenzeModalOpen",
    apiKeyField: "spolehlivaRecenzeShopPassword",
    onlyUsaVisible: false, // Not visible in USA
  },
  googleReviews: {
    name: "Google Reviews",
    type: "googleReviews",
    modalSetter: "setGoogleReviewsModalOpen",
    apiKeyField: "googleReviewsPlaceId",
  },
  trustPilot: {
    name: "TrustPilot Reviews",
    type: "trustPilot",
    modalSetter: "setTrustPilotModalOpen",
    apiKeyField: "trustpilotBusinessUnitId",
    onlyUsaVisible: true, // Only visible in USA
  },
};
